import { useMemo } from 'react';

import {
    useCheckPromoCode
} from 'server';

export const usePromoCodePublicAPI = () => {
    const checkPromoCode = useCheckPromoCode();

    return useMemo(() => ({
        /**
         *
         * @memberOf Playtech.API.bonus
         * @function
         * @param {Object} options
         * @param {string} options.promocode
         * @returns {Promise<{ code: string }>}
         * @example
         * Playtech.API.promoCode.checkPromoCode({
         *  promocode: 'TEST'
         * }).then(() => {...});
         */
        checkPromoCode
    }), [
        checkPromoCode
    ]);
};
